import { action } from 'typesafe-actions';
import { UserRightsResources } from '../UserManagement/Types';
import { IUserActionTypes, IUserInfo } from './Types';

export const login = (username: string, password: string) =>
	action(IUserActionTypes.LOGIN, [username, password]);
export const logout = () => action(IUserActionTypes.LOGOUT);
export const loginSuccess = (
	username: string,
	groupID: number,
	token: string,
	expires: number,
	userInfo: IUserInfo,
	userManagementRights: UserRightsResources
) =>
	action(IUserActionTypes.LOGIN_SUCCESS, [
		username,
		groupID,
		token,
		expires,
		userInfo,
		userManagementRights,
	]);
export const logoutSuccess = () => action(IUserActionTypes.LOGOUT_SUCCESS);
export const loginError = () => action(IUserActionTypes.LOGIN_ERROR);
